import { render } from "./SearchSidebar.vue?vue&type=template&id=31ab89e4"
import script from "./SearchSidebar.vue?vue&type=script&lang=js"
export * from "./SearchSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/webmobtuts/realestateapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__